// utils.js — generic, non-CRM utility functions
// CRM-specific functions (getPermissions, get_crm_user_id) live in src/CRM/SimpleCRM/crmUtils.js

export const getFilterForUser = () => {
    const getCookie = (name) => {
        const cookies = document.cookie.split("; ");
        const cookie = cookies.find(c => c.startsWith(`${name}=`));
        return cookie ? cookie.split("=")[1] : null;
    };

    const id = getCookie("user_id");
    const role = getCookie("user_role");

    if (!id) {
        console.warn("User ID not found in cookies!");
        return "";
    }
    if (['admin', 'superadmin', 'manager'].includes(role)) {
        return ``;
    }
    return `?fkUserId=${id}`;
};

export const getStatusFilterForUser = (status) => {
    const getCookie = (name) => {
        const cookies = document.cookie.split("; ");
        const cookie = cookies.find(c => c.startsWith(`${name}=`));
        return cookie ? cookie.split("=")[1] : null;
    };

    const id = getCookie("user_id");
    const role = getCookie("user_role");

    if (!id) {
        console.warn("User ID not found in cookies!");
        return "";
    }
    if (['admin', 'superadmin', 'manager'].includes(role)) {
        return ``;
    }
    return `&status=${status}`;
};
